export function getHeaderFormDetails(state = 'Visão geral', action) {
  if (action.type === 'GET_HEADER_FORM_DETAILS') {
    return action.nameFormDetails;
  }
  return state;
}
